import { OkCancelButtonsBefore } from "lib/@components/okCancel"
import { ChangedTaskBelow, ChangedTaskEnd, ChangedTaskWrapper } from "../../changed-task"
import { TailoredScheduleAccordionAdditional, TailoredScheduleWrapper } from "../../tailored-schedule"
import { RemoveJustification } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/remove-justification"
import { Justification } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/justification"
import { JustifyTailoringButton } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/justify-tailoring-button"
import { TailoredScheduleAccordionActions } from "./tailored-schedule-accordion-actions"
import { TailoredTabScheduleAudit } from "./tailored-tab-schedule-audit"
import { TailoredTabTaskAudit } from "./tailored-tab-task-audit"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { isInEditableRegime } from "routes/facilities/lib/when-parent-item"
import { Bound } from "lib/@components/binding/Bound"

export function TailoredTabAuditing({ children }) {
    const { regime } = useBoundContext()
    const isEditable = isInEditableRegime(regime)

    ChangedTaskEnd.usePlug(<JustifyTailoringButton />)
    ChangedTaskBelow.usePlug(<Justification />)
    OkCancelButtonsBefore.usePlug(<RemoveJustification />)

    TailoredScheduleAccordionAdditional.usePlug(<TailoredScheduleAccordionActions />)
    TailoredScheduleWrapper.usePlug(<TailoredTabScheduleAudit />)
    ChangedTaskWrapper.usePlug(<TailoredTabTaskAudit />)

    return <Bound isEditable={isEditable}>{children}</Bound>
}
